import { Injectable } from '@angular/core';
import { UserProfil } from './auth/user-profile.model';
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../../environments/environment';
import { isToggleGestionStocksEnabled } from '../utils/toggle-utils';

export enum MenuPage {
  Home = 0,
  Sites = 1,
  CRT = 2,
  Cr = 3,
  Rapport = 4,
  Profil = 5,
  Planning = 6,
  AgendaEquipe = 7,
  Securite = 8,
  IOT = 9,
  NewsIndispo = 10,
  ChangeUser = 11,
  Aide = 12,
  DeclareDysfonctionnement = 13,
  Tournee = 14,
  Admin = 15,
  Travaux = 16,
  GestionStocks = 17,
  SansMenu = -1,
}

@Injectable({ providedIn: 'root' })
export class MenuService {
  /**
   * Liste des éléments du menu
   */
  public menu: MenuItem[] = [
    {
      title: MenuTitle.Home,
      icon: 'home',
      action: MenuPage.Home,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Diffus, UserProfil.Mnt],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/shared/accueil',
      highlight: false,
      active: true,
    },
    {
      title: MenuTitle.Planning,
      icon: 'agenda-vue-jour',
      action: MenuPage.Planning,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Diffus, UserProfil.Mnt],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/mnt/agenda/jour?forceRefresh=true',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.AgendaEquipe,
      icon: 'agenda-vue-equipe',
      action: MenuPage.AgendaEquipe,
      disabled: false,
      visible: true,
      chrono: false,
      profils: [UserProfil.Diffus, UserProfil.Mnt],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/mnt/agenda/equipe',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Tournee,
      icon: 'git-merge',
      action: MenuPage.Tournee,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Mnt, UserProfil.Diffus],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/mnt/round',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Sites,
      icon: 'list-outline',
      action: MenuPage.Sites,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Mnt, UserProfil.Diffus],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/mnt/sites',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Cr,
      icon: 'copy',
      action: MenuPage.Cr,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Mnt, UserProfil.Diffus],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/mnt/crs',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Travaux,
      icon: 'demande-de-travaux-nofill',
      action: MenuPage.Travaux,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Mnt, UserProfil.Diffus, UserProfil.Travaux],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/mnt/travaux',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.GestionStocks,
      icon: 'cube-outline',
      action: MenuPage.GestionStocks,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Mnt, UserProfil.Diffus, UserProfil.Magasinier],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/gestion-stocks',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Rapport,
      icon: 'refresh',
      action: MenuPage.Rapport,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Mnt, UserProfil.Diffus],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/shared/rapport',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Securite,
      icon: 'alert-circle',
      action: MenuPage.Securite,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Mnt, UserProfil.Diffus, UserProfil.Travaux, UserProfil.Magasinier],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/mnt/securite',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Crt,
      icon: 'crt-home',
      action: MenuPage.CRT,
      disabled: false,
      visible: true,
      chrono: false,
      profils: [UserProfil.CRTLecture, UserProfil.CRTLectureEcriture],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/crt',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Iot,
      icon: 'iot-home',
      action: MenuPage.IOT,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.IoT],
      notifications: 0,
      position: MenuPosition.Top,
      url: '/iot',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Profil,
      icon: 'person',
      action: MenuPage.Profil,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [
        UserProfil.Mnt,
        UserProfil.Diffus,
        UserProfil.CRTLecture,
        UserProfil.CRTLectureEcriture,
        UserProfil.IoT,
        UserProfil.Admin,
        UserProfil.Travaux,
        UserProfil.Magasinier,
      ],
      notifications: 0,
      position: MenuPosition.Bottom,
      url: '/shared/user',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.newsIndispo,
      icon: 'construct',
      action: MenuPage.NewsIndispo,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.CRTLecture, UserProfil.CRTLectureEcriture],
      notifications: 0,
      position: MenuPosition.Bottom,
      url: '/crt/news-indispo',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.DeclarerDysfonctionnement,
      icon: 'menu-dysfonctionnement',
      action: MenuPage.DeclareDysfonctionnement,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.CRTLecture, UserProfil.CRTLectureEcriture, UserProfil.IoT],
      notifications: 0,
      position: MenuPosition.Bottom,
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Aide,
      icon: 'help-circle',
      action: MenuPage.Aide,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.Mnt, UserProfil.Diffus, UserProfil.IoT, UserProfil.Travaux, UserProfil.Magasinier],
      notifications: 0,
      position: MenuPosition.Bottom,
      url: '/shared/aide',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.Admin,
      icon: 'settings-sharp',
      action: MenuPage.Admin,
      disabled: false,
      visible: true,
      chrono: true,
      profils: [UserProfil.SuperAdmin],
      notifications: 0,
      position: MenuPosition.Bottom,
      url: '/mnt/admin',
      highlight: false,
      active: false,
    },
    {
      title: MenuTitle.ChangeUser,
      icon: 'exit-outline',
      action: MenuPage.ChangeUser,
      disabled: false,
      visible: true,
      chrono: false,
      profils: [UserProfil.Admin],
      notifications: 0,
      position: MenuPosition.Bottom,
      url: '/shared/to-implement',
      highlight: true,
      active: false,
    },
  ];

  private disabledOffline = [
    MenuTitle.AgendaEquipe,
    MenuTitle.Sites,
    MenuTitle.ChangeUser,
    MenuTitle.Travaux,
    MenuTitle.Aide,
    MenuTitle.Securite,
    MenuTitle.GestionStocks,
  ];

  previousActiveTitle: MenuTitle = MenuTitle.Home;

  constructor() {
    Network.addListener('networkStatusChange', (status) => {
      if (status.connected) {
        this.refreshItems(true);
      } else {
        this.refreshItems(false);
      }
    });
  }

  /**
   * Refresh links when network change
   */
  refreshItems(connected) {
    for (const item of this.menu) {
      if (this.disabledOffline.includes(item.title)) {
        item.disabled = !connected;
      }
    }
  }

  getMenu(): MenuItem[] {
    let menuFiltered = [...this.menu];
    if (!isToggleGestionStocksEnabled()) {
      menuFiltered = menuFiltered.filter((item) => item.title !== MenuTitle.GestionStocks);
    }
    if (!Capacitor.isNativePlatform() && environment.production) {
      menuFiltered = menuFiltered.filter((item) => {
        return (
          item.title !== MenuTitle.Crt &&
          item.title !== MenuTitle.Iot &&
          item.title !== MenuTitle.newsIndispo &&
          item.title !== MenuTitle.DeclarerDysfonctionnement
        );
      });
    }
    if (Capacitor.isNativePlatform())
      menuFiltered = menuFiltered.filter((item) => {
        return item.title !== MenuTitle.Admin;
      });
    return menuFiltered;
  }

  /**
   * Retourne les éléments du haut du menu
   */
  getMenuTop(): MenuItem[] {
    return this.getMenu().filter((item) => {
      return item.position === MenuPosition.Top;
    });
  }

  /**
   * Retourne les éléments du bas du menu
   */
  getMenuBottom(): MenuItem[] {
    return this.getMenu().filter((item: MenuItem) => {
      return item.position === MenuPosition.Bottom;
    });
  }

  /**
   * Définit la valeur de notification associé à un élement du menu
   * @param menuTitle Titre du menu
   * @param value Valeur de la notification
   */
  setItemNotification(menuTitle: MenuTitle, value: number) {
    const menuItem = this.menu.find((item) => item.title === menuTitle);
    if (menuItem) {
      menuItem.notifications = value;
    }
  }

  /**
   * Retourne la somme des notifications du menu
   */
  getNotifications(): number {
    return this.menu.reduce((sum, item) => sum + item.notifications, 0);
  }

  desactive(title: MenuTitle) {
    const link: MenuItem = this.menu.find((item) => item.title === title);
    if (!link?.active) {
      const index = this.menu.findIndex((x) => x.active);
      this.previousActiveTitle = this.menu[index].title;
      this.menu[index].active = false;
      link.active = true;
    }
  }

  rollBackToPreviousMenu() {
    this.desactive(this.previousActiveTitle);
  }
}

export interface MenuItem {
  title: MenuTitle;
  icon: string;
  action: MenuPage;
  disabled: boolean;
  visible: boolean;
  profils: UserProfil[];
  notifications: number;
  chrono: boolean;
  position: MenuPosition;
  url?: string;
  highlight: boolean;
  active: boolean;
}

export enum MenuTitle {
  Planning = 'Planning',
  AgendaEquipe = 'Vue Équipe',
  Tournee = 'Tournée',
  Sites = 'Sites',
  Crt = 'eCRT',
  Iot = 'IoT - Objets connectés',
  Cr = 'CR Saisis',
  Travaux = 'Travaux',
  Rapport = 'Rapport de synchronisation',
  newsIndispo = 'News & Indisponibilités eCRT',
  Profil = 'Profil',
  Securite = 'QSE',
  GestionStocks = 'Gestion de stocks',
  Aide = 'Aide',
  ChangeUser = "Changer d'utilisateur",
  DeclarerDysfonctionnement = 'Déclarer un incident eCRT',
  Home = 'Accueil',
  Admin = 'Admin',
}

export enum MenuPosition {
  Top = 'top',
  Bottom = 'bottom',
}
